module.exports = __webpack_public_path__ + "img/palisade.5c916b11.png";